export default __webpack_public_path__ + "static/media/poder-01.b3c853ae.jpg";